import Jt808DevicesForTerminalnumModal from './jt808-devices-for-terminalnum-modal.vue'
export default Jt808DevicesForTerminalnumModal
